module.exports = __webpack_public_path__ + "static/media/pantalla_vertical.a0b84ff6.png";